import React from 'react';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  standardColours,
  brandColours,
  brandFonts,
  fontWeights,
  fontSize,
} from '../styles';
import { Button, Image } from './ui';
import { formatPrice } from '../utils';

const StyledContentCard = styled.article`
  display: flex;
  flex-direction: column;
  background-color: ${({ alt }) =>
    alt ? standardColours.white : brandColours.senary};
`;

const StyledContent = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 25px;

  ${minBreakpointQuery.medium`
    padding: 30px;
  `}

  ${minBreakpointQuery.xxlarge`
    padding: 35px;
  `}
`;

const StyledHeading = styled.h3`
  ${brandFonts.secondary};
  ${fontSize(29)};
  line-height: 1.1;

  ${minBreakpointQuery.small`
    ${fontSize(32)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(35)};
  `}
`;

const StyledText = styled.div`
  ul {
    margin: 0 0 10px 20px;
    list-style-type: disc;
  }

  li {
    margin-top: 8px;
    line-height: 1.5;

    ${minBreakpointQuery.small`
      ${fontSize(18)};
    `}

    &:first-child {
      margin-top: 0;
    }
  }
`;

const StyledPrice = styled.p`
  font-weight: ${fontWeights.medium};
  ${fontSize(19)};

  ${minBreakpointQuery.small`
    ${fontSize(22)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(25)};
  `}
`;

const StyledButton = styled(Button)`
  margin-top: auto;
`;

const ContentCard = ({
  image,
  heading,
  text,
  price,
  button,
  alt,
  ...props
}) => (
  <StyledContentCard alt={alt} {...props}>
    {image && (
      <Image
        src={image.url}
        alt={image.title}
        width={580}
        height={280}
        layout="constrained"
      />
    )}
    <StyledContent>
      <StyledHeading>{heading}</StyledHeading>
      {text && <StyledText dangerouslySetInnerHTML={{ __html: text }} />}
      {price && <StyledPrice>{formatPrice(price)}</StyledPrice>}
      {button && (
        <StyledButton to={button.url} alt={true}>
          {button.text}
        </StyledButton>
      )}
    </StyledContent>
  </StyledContentCard>
);

export default ContentCard;
